// store/auth.js

// import * as dashboard from './user';
import axios from "axios";
import { apis } from '../../apis/company';
import router from "../../../router/routes";

const state = {
    // Additional state if needed
    companyDetails: '',
}

const mutations = {
    SET_PROFILE_DETAILS_DATA(state, data) {
        state.companyDetails = data
    },
}

const actions = {
    // Additional actions if needed

    getCompanyProfile({ commit }, id) {
          // return
          // return new Promise((resolve, reject) => {
              axios
                  .get(axios.defaults.baseURL + apis.GET_PROFILE_BY_ID + id, {
                      headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                      },
                    })
                  .then((res) => {
                      console.log('getCompanyProfile res', res)
                      commit('SET_PROFILE_DETAILS_DATA', res.data)
                  })
                  .catch((err) => {
                      console.log('getCompanyProfile err', err)
                  })
          // })
    },

    editCompanyProfile({dispatch, commit}, payload) {
        console.log("payload--", payload);
        // return
        var formData = new FormData();
        formData.append("company", payload.company);
        formData.append("representative", payload.representative);
        formData.append("address", payload.address);
        formData.append("contact", payload.contact);
        formData.append("service", payload.service);
        formData.append("mcnumber", payload.mcnumber);
        formData.append("dotnumber", payload.dotnumber);
        formData.append("companysize", payload.companysize);
        formData.append("facebook", payload.facebook);
        formData.append("twitter", payload.twitter);
        formData.append("instagram", payload.instagram);
        formData.append("youtube", payload.youtube);
        formData.append("description", payload.description);
        formData.append("image", payload.image);
        return new Promise((resolve, reject) => {
          axios
            .post(axios.defaults.baseURL + apis.EDIT_PROFILE_BY_ID + payload.id, formData,{
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token"),
              },
            })
            .then((res) => {
              console.log("editCompanyProfile res", res);
              commit("UPDATE_LOADING_STATE", false);
              resolve(res);
              dispatch("checkErrorAndSendToast", [
                res,
                "success",
              ]);
              router.push("/profile")
            })
            .catch((err) => {
              console.log("editCompanyProfile err", err);
              reject(err);
              dispatch("checkErrorAndSendToast", [
                err.response,
                "error",
              ]);
            });
        })
      },

}

const getters = {
    // Additional getters if needed
}

export default {
    state,
    mutations,
    actions,
    getters,
  };